<template>
    <div class="reporting md-layout md-alignment-top-center">
        <md-card class="md-layout-item md-size-65">
            <md-card-header>
                <h1 class="md-title">Monthly Balance Report</h1>
            </md-card-header>
            <md-card-content>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item">
                        <md-field>
                            <label for="year">Year</label>
                            <md-select v-model="selectedYear" name="year" id="year">
                                <md-option v-for="(year, index) of years" :key="index" :value="year">{{year}}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div class="md-layout-item">
                        <md-field>
                            <label for="month">Month</label>
                            <md-select v-model="selectedMonth" name="month" id="month">
                                <md-option v-for="m of months" :key="m.value" :value="m.value">{{m.name}}</md-option>
                            </md-select>
                        </md-field>
                    </div>
                </div>
            </md-card-content>
            <md-card-actions>
                <md-button @click="getReports()">Run</md-button>
            </md-card-actions>
        </md-card>
        <md-progress-bar md-mode="indeterminate" v-show="monthlyLoading" class="md-accent md-layout-item md-size-65"></md-progress-bar>
        <div class="spacer md-layout-item md-size-100"></div>
        <md-table class="md-layout-item md-size-65" v-if="!monthlyLoading && !initialLoad" md-card md-fixed-header md-height="auto" v-model="monthlyTransactions">
            <md-table-toolbar v-if="bankBalance !== 0">
                <div class="md-toolbar-section-start">
                    <h1 class="md-title">Bank Balance: {{bankBalance | currency}}</h1>
                </div>
            </md-table-toolbar>
             <md-table-empty-state
                md-label="No changes"
                :md-description="'No transactions happened this month, check a different month.'"
                >
             </md-table-empty-state>
            <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Name">{{item.accountName}}</md-table-cell>
        <md-table-cell md-label="Amount" :class="{'red': item.amount < 0, 'green': item.amount > 0}">{{item.amount | currency}}</md-table-cell>
        <md-table-cell md-label="Date">{{item.timestamp | date}}</md-table-cell>
      </md-table-row>
        </md-table>
    </div>
</template>

<script>
import { db }from '@/db';
import { mapGetters } from 'vuex';
const monthsList = [
    { value: 0, name: 'January' },
    { value: 1, name: 'February' },
    { value: 2, name: 'March' },
    { value: 3, name: 'April' },
    { value: 4, name: 'May' },
    { value: 5, name: 'June' },
    { value: 6, name: 'July' },
    { value: 7, name: 'August' },
    { value: 8, name: 'September' },
    { value: 9, name: 'October' },
    { value: 10, name: 'November' },
    { value: 11, name: 'December' }
];
export default {
    name: "Reporting",
    data: ()=>({
        currentDate: new Date(),
        selectedYear: new Date().getFullYear(),
        selectedMonth: new Date().getMonth(),
        initialLoad: true,
    }),
    computed:{
        years: function(){
            let list = [];
            let d = new Date();
            list.push(d.getFullYear())
            while(d.getFullYear() > 2016){
                d.setFullYear(d.getFullYear() - 1);
                list.push(d.getFullYear())
            }
            return list;
        },
        months: function(){
            if(this.selectedYear === this.currentDate.getFullYear()){
                return monthsList.filter(m => m.value <= this.currentDate.getMonth())
            }
            return monthsList;
        },
        bankBalance: function(){
            return this.monthlyTransactions.length > 0 ? this.monthlyTransactions[0].bankBalance : 0;
        },
        ...mapGetters(['monthlyTransactions', 'monthlyLoading'])
    },
    methods:{
        getReports(){
            let start = new Date(this.selectedYear, this.selectedMonth, 1).toIsoString();
            let end;
            if(this.selectedMonth === 11){
                end = new Date(this.selectedYear + 1, 0, 1);
            }
            else{
                end = new Date(this.selectedYear, this.selectedMonth + 1, 1);
            }
            end.setTime(end.getTime() - 24*60*60*1000);
            end = end.toIsoString();
            this.$store.dispatch('setMonthlyTransactions', {ref : db.ref('bankTransactions').orderByChild('timestamp').startAt(start).endAt(end)});
            this.initialLoad = false;
        }
    }

}
</script>

<style lang="scss">

</style>
